module.exports = __webpack_public_path__ + "static/img/iwatch_Nike3.26fbdbef.jpg";